module.exports = __webpack_public_path__ + "static/media/third.d2ba2a3e.png";